import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";

import { type KnownFixDetails } from "./knownErrorFixes";

export function ErrorDetailsButton({
  fullMessage,
  knownFix,
}: {
  fullMessage: string;
  knownFix?: KnownFixDetails;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button color="inherit" size="small" onClick={() => setOpen(true)}>
        Details
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        onClick={(e) => e.stopPropagation()}
        slotProps={{
          paper: {
            sx: { maxHeight: "70vh", maxWidth: "80ch" },
          },
        }}
      >
        <DialogTitle>Error Details</DialogTitle>
        <DialogContent>
          {knownFix && (
            <Alert
              severity={
                knownFix.snackbarVariant === "default"
                  ? "info"
                  : knownFix.snackbarVariant
              }
              sx={{ mb: 5 }}
            >
              <AlertTitle>{knownFix.title}</AlertTitle>
              {knownFix.fixContent}
            </Alert>
          )}
          <DialogContentText
            sx={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              fontFamily: "monospace",
            }}
          >
            {fullMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
